import React from 'react';

import styles from './Signature.module.css';
import Files from './components/Files';
import Key from './components/Key';
import {Button, FormControlLabel, Radio, RadioGroup} from '@mui/material';
import {labelStyles} from '../../common/styles/formStyles';
import InputLabel from '@mui/material/InputLabel';
import {Permission} from "../../components/SessionInfo";
import {hetch} from "../../utils/fetch.hooked";

const filterUnsignedFiles = ({files, signType}) => {
  return Object.entries(files).reduce((filteredFiles, [id, file]) => {
    const isUnsignedFile = file.status !== 'signed' || file.signType !== signType;
    const isInvalidFileType = signType === 'readyXML' && !file.file.name.endsWith('.xml');
    if (isUnsignedFile && !isInvalidFileType) {
      filteredFiles[id] = file;
    }
    return filteredFiles;
  }, {});
};

const signFiles = ({files, signType, setFiles, keyName, onAllFinally}) => {
  const signEndpointMap = {
    'onlySign': '/api/sign/data',
    'readyXML': '/api/sign/xml',
  };
  Promise.all(Object
    .entries(files)
    .map(([id, {file}]) => {
      const formData = new FormData();
      formData.append('doc_to_sign', file);
      formData.append('key_name', keyName);
      if (signType === 'readyXML') {
        formData.append('sign_type', 'readyXML');
      }
      setFiles((prevFiles) => ({
        ...prevFiles,
        [id]: {
          ...prevFiles[id],
          status: 'loading',
        }
      }));
      return hetch(signEndpointMap[signType], {
        headers: {
          'Correlation-id': '1',
        },
        method: 'POST',
        body: formData,
      })
        .then((res) => {
          if (res.status === 200) {
            return res.text().then((signature) => {
              const nameChunks = file.name.split('.');
              nameChunks.splice(nameChunks.length - 1, Number(signType === 'onlySign'), 'sig');
              const signedFileName = nameChunks.join('.');
              setFiles((prevFiles) => ({
                ...prevFiles,
                [id]: {
                  ...prevFiles[id],
                  status: 'signed',
                  signedFile: new File([signature], signedFileName),
                  signType,
                }
              }));
            });
          }
          setFiles((prevFiles) => ({
            ...prevFiles,
            [id]: {
              ...prevFiles[id],
              status: 'error',
              signed: undefined,
            }
          }));
        })
        .catch((err) => {
          console.error(err);
          setFiles((prevFiles) => ({
            ...prevFiles,
            [id]: {
              ...prevFiles[id],
              status: 'error',
              signed: undefined,
            }
          }));
        })
  })).finally(onAllFinally);
};

export default function Signature({ permission }) {
  const [files, setFiles] = React.useState({});
  const [keyName, setKeyName] = React.useState(null);
  const [signType, setSignType] = React.useState('onlySign');
  const [isLoading, setIsLoading] = React.useState(false);
  const unsignedFiles = filterUnsignedFiles({files, signType});
  const isDisabledSign = isLoading || !keyName || Object.keys(unsignedFiles).length === 0;
  return (
    <div className={styles.signature}>
      <div>
        <div className={styles.filesContainer}>
          <InputLabel htmlFor='serialNumber' sx={labelStyles} required={true}>Файлы для подписи</InputLabel>
          <Files
            files={files}
            setFiles={setFiles}
            signType={signType}
          />
        </div>
      </div>
      <div className={styles.keyContainer}>
        <Key keyName={keyName} setKeyName={setKeyName}/>
      </div>
      <div className={styles.signTypeContainer}>

          <InputLabel htmlFor='serialNumber' sx={labelStyles} required={true}>Тип подписи</InputLabel>
          <RadioGroup
            value={signType}
            onChange={(_, value) => {setSignType(value)}}
          >
            <FormControlLabel value="onlySign" control={<Radio/>} label="Открепленная" />
            <FormControlLabel value="readyXML" control={<Radio/>} label="Прикрепленная (только для XML файлов)" />
          </RadioGroup>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{
              marginTop: '16px',
              background: isDisabledSign ? undefined : 'linear-gradient(129.04deg, #FDAB2F 8.28%, rgba(255, 98, 154, 0.94) 51.96%, #7C0DEB 99.16%)',
              color: 'white',
            }}
            fullWidth
            disabled={isDisabledSign || permission !== Permission.WRITE}
            onClick={() => {
              setIsLoading(true);
              signFiles({
                files: unsignedFiles,
                setFiles,
                keyName,
                signType,
                onAllFinally() {
                  setIsLoading(false);
                }
              });
            }}
          >Подписать</Button>

      </div>
    </div>
  );
}
